import { render, staticRenderFns } from "./DomainOppositionOwnerList.vue?vue&type=template&id=26da2128&"
import script from "./DomainOppositionOwnerList.vue?vue&type=script&lang=js&"
export * from "./DomainOppositionOwnerList.vue?vue&type=script&lang=js&"
import style0 from "./DomainOppositionOwnerList.vue?vue&type=style&index=0&id=26da2128&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports